import Application from "../../Application";
import PortalReportingPeriodPresenter, {
  IPortalReportingPeriodPresenter
} from "../../presenter/portal/PortalReportingPeriodPresenter";
import { IApplicantService } from "../../service/applicant/ApplicantService";
import { IPortalReportingPeriodService } from "../../service/reporting/PortalReportingPeriodService";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";
import { INotificationService } from "../../service/notification/NotificationService";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { UserPreferences } from "../../common/Constants";
import { IPortalApplicant } from "../../model/applicant/PortalApplicant";

export default class ShowPortalReportingPeriodInteractor {
  private application: Application;
  private output?: IPortalReportingPeriodPresenter;
  private applicantService: IApplicantService;
  private portalReportingPeriodService: IPortalReportingPeriodService;
  private notificationService: INotificationService;
  private credentialsService: ICredentialsService;

  constructor(
    application,
    applicantService,
    portalReportingPeriodService,
    notificationService,
    credentialsService
  ) {
    this.application = application;
    this.applicantService = applicantService;
    this.portalReportingPeriodService = portalReportingPeriodService;
    this.notificationService = notificationService;
    this.credentialsService = credentialsService;
  }

  async getReportingPeriodApplicants(reportingPeriodId: number) {
    try {
      let currentLanguage = Number(await this.credentialsService.getLanguage());
      if (!currentLanguage) {
        currentLanguage = UserPreferences.DEFAULT_LANGUAGE;
      }
      const applicants =
        await this.applicantService.getReportingPeriodApplicants(
          reportingPeriodId,
          currentLanguage
        );
      return applicants;
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  async getReportingPeriod(reportingPeriodId: number) {
    try {
      let currentLanguage = Number(await this.credentialsService.getLanguage());
      if (!currentLanguage) {
        currentLanguage = UserPreferences.DEFAULT_LANGUAGE;
      }
      const reportingPeriod =
        await this.portalReportingPeriodService.getReportingPeriod(
          reportingPeriodId,
          currentLanguage
        );
      return reportingPeriod;
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute(reportingPeriodId: number) {
    this.output = PortalReportingPeriodPresenter({
      application: this.application,
      initialState: {
        applicants: [],
        reportingPeriodId,
        reportingPeriod: {} as IReportingPeriod,
        forms: []
      }
    });

    this.getReportingPeriod(reportingPeriodId).then((reportingPeriod) =>
      this.output?.loadReportingPeriod(
        reportingPeriod || ({} as IReportingPeriod)
      )
    );

    this.getReportingPeriodApplicants(reportingPeriodId).then((applicants) =>
      this.output?.loadApplicants(applicants || ([] as IPortalApplicant[]))
    );

    return this.output;
  }
}
